import React from 'react'
import { CONSTANTS_STRINGS } from '../../Utils/Constant';

function Service() {
    return (
      <>
        {/* Services Section */}
        <div className="bg-white pt-15 pb-20">
          <div className="flex  justify-center w-[85%] h-auto mx-auto bg-gray-100   px-10 py-15 shadow ">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  gap-8 w-full ">
              {CONSTANTS_STRINGS.services.map((service, index) => {
                const Icon = service.icon;
                return (
                  <div
                    key={index}
                    className="p-6 hover:bg-white transition-colors rounded-lg "
                  >
                    <Icon
                      className="text-gray-500 text-3xl mb-4"
                      style={{ fontSize: 40 }}
                    />
                    <h3 className="text-2xl font-semibold mb-3">
                      {service.title}
                    </h3>
                    <p className="text-gray-600">{service.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
}

export default Service
